// third-party
import { FormattedMessage } from 'react-intl';

// assets
import SupportIcon from '@mui/icons-material/Support';

const demoRequests = {
    id: 'demo-requests',
    title: <FormattedMessage id="demo-requests" />,
    icon: SupportIcon,
    type: 'group',
    url: 'demo-requests',
    roles: ['admin', 'cs-others']
};

export default demoRequests;
